import { render, staticRenderFns } from "./AISuraksha.vue?vue&type=template&id=51de5f3c&"
import script from "./AISuraksha.vue?vue&type=script&lang=js&"
export * from "./AISuraksha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports